module.exports = __webpack_public_path__ + "img/ellipse415.3e6d0d3c.png";